module.exports = __webpack_public_path__ + "img/4.70c58b03.jpg";